export * from './IStack.js';
export * from './IStackMutable.js';
export * from './IStackImmutable.js';
export * from './StackImmutable.js';
export * from './StackMutable.js';
export type * from './types.js';
export * from './StackFns.js';